/**
 * Module Enable/Disable Flags (Frontend)
 *
 * Mirrors the backend MODULE_* flags from .env.
 * These control which modules are visible in the sidebar navigation
 * and accessible via the API.
 *
 * IMPORTANT: Keep in sync with backend/.env MODULE_* flags.
 * Changes here require a rebuild of the frontend.
 */

export const MODULE_FLAGS = {
  // Phase 1: Hospital modules (old surgery replaced by ambulatory surgical-procedures)
  emergency: import.meta.env.VITE_MODULE_EMERGENCY !== 'false',
  admissions: import.meta.env.VITE_MODULE_ADMISSIONS !== 'false',
  surgery: import.meta.env.VITE_MODULE_SURGERY !== 'false',   // new features/surgery/ (features/surgery/surgeryService.ts → /api/surgical-procedures/*)
  nursing: import.meta.env.VITE_MODULE_NURSING !== 'false',
  // Phase 2+ targets (default enabled for now)
  imaging: import.meta.env.VITE_MODULE_IMAGING !== 'false',
  pharmacy: import.meta.env.VITE_MODULE_PHARMACY !== 'false',
  lab: import.meta.env.VITE_MODULE_LAB !== 'false',
  billing: import.meta.env.VITE_MODULE_BILLING !== 'false',
  reports: import.meta.env.VITE_MODULE_REPORTS !== 'false',
  admin: import.meta.env.VITE_MODULE_ADMIN !== 'false',
  // Patient portal (PR #1: Auth + Portal Backend + Frontend)
  patient_portal: import.meta.env.VITE_MODULE_PATIENT_PORTAL !== 'false',
  // PQRS (Patient Complaints and Suggestions)
  pqrs: import.meta.env.VITE_MODULE_PQRS !== 'false',
  // Historia Clinica Module (SOAP + Review of Systems)
  historia_clinica: import.meta.env.VITE_MODULE_HISTORIA_CLINICA !== 'false',
} as const;

export type ModuleName = keyof typeof MODULE_FLAGS;

/**
 * Check if a module is enabled.
 * @param name Module name
 * @returns true if enabled, false if soft-disabled
 */
export function isModuleEnabled(name: ModuleName): boolean {
  return MODULE_FLAGS[name];
}

/**
 * Get all disabled module names.
 * Useful for debugging or admin interfaces.
 */
export function getDisabledModules(): ModuleName[] {
  return (Object.keys(MODULE_FLAGS) as ModuleName[]).filter(
    (name) => !MODULE_FLAGS[name]
  );
}